import React, { ReactNode } from 'react';
import sprite from '../img/icons/spriteServices.svg';

interface propsServicesCard {
	children?: ReactNode,
	icon?: string,
	className?: string,
}

function ServicesCard({ children, icon, className }: propsServicesCard) {
	return (
		<li className={`services-card ${className}`}>
			<div className="services-card__body">
				<svg className="services-card__icon">
					<use href={sprite + '#' + icon} />
				</svg>
				<div className="services-card__text">
					{children}
				</div>
			</div>
		</li>
	);
}

export default ServicesCard;
